import { render, staticRenderFns } from "./GroupProvincesVue.vue?vue&type=template&id=8a7336b8&scoped=true&"
import script from "./GroupProvincesVue.vue?vue&type=script&lang=js&"
export * from "./GroupProvincesVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7336b8",
  null
  
)

export default component.exports